// frontend/src/utils/fieldValidators.js
//
// Optional-field validators. Every helper returns true when the
// value is EMPTY (blank), because these fields are optional. It
// only returns false when the user has typed something invalid.
//
// This file is intentionally separate from utils/validators.js
// so we never touch the existing exported object.

const EMAIL_RE = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
const ZIP_RE = /^\d{5}(-\d{4})?$/;

export function digitsOnly(value) {
  return String(value || "").replace(/\D/g, "");
}

export function optionalPhone(value) {
  if (!value || !String(value).trim()) return true;
  const digits = digitsOnly(value);
  return digits.length >= 10 && digits.length <= 15;
}

export function optionalEmail(value) {
  if (!value || !String(value).trim()) return true;
  return EMAIL_RE.test(String(value).trim());
}

export function optionalUrl(value) {
  if (!value || !String(value).trim()) return true;
  const v = String(value).trim();
  try {
    new URL(v.startsWith("http") ? v : `https://${v}`);
    return true;
  } catch {
    return false;
  }
}

export function optionalZip(value) {
  if (!value || !String(value).trim()) return true;
  return ZIP_RE.test(String(value).trim());
}

export function optionalPositiveInt(value) {
  if (value === "" || value === null || value === undefined) return true;
  const n = Number(value);
  return Number.isInteger(n) && n > 0;
}

export function optionalDate(value, { notFuture = false, notPast = false } = {}) {
  if (!value || !String(value).trim()) return true;
  const d = new Date(value);
  if (Number.isNaN(d.getTime())) return false;
  const now = new Date();
  if (notFuture) {
    const oneYearAhead = new Date(now);
    oneYearAhead.setFullYear(now.getFullYear() + 1);
    if (d > oneYearAhead) return false;
  }
  if (notPast) {
    const today = new Date();
    today.setHours(0, 0, 0, 0);
    if (d < today) return false;
  }
  return true;
}

export function optionalText(value, max = 2000) {
  if (!value || !String(value).trim()) return true;
  return String(value).trim().length <= max;
}